import React from 'react'
import PropTypes from 'prop-types'
import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Text,
} from '@chakra-ui/react'

export const ExpandablePanel = ({
  title,
  completedClosedContent,
  isDisabled,
  children,
}) => {
  return (
    <AccordionItem
      borderRadius="lg"
      border="none"
      background="white"
      boxShadow="lg"
      rounded="md"
      isDisabled={isDisabled}
    >
      {({isExpanded}) => (
        <>
          <AccordionButton
            py="md"
            pt="md"
            borderTopRadius="lg"
            // If expanded, remove hover background/styles
            _hover={isExpanded ? {bg: 'none'} : {bg: 'mld.neutral.100'}}
            // Optionally change cursor if it's not meant to be clicked
            cursor={isExpanded ? 'default' : 'pointer'}
          >
            <Flex width="100%" direction="column" align="flex-start">
              <Flex width="100%" justify="space-between">
                <Text textStyle="headline4">{title}</Text>
                <AccordionIcon />
              </Flex>

              {!isExpanded && completedClosedContent && (
                <Box pt="sm" width="100%">
                  {completedClosedContent}
                </Box>
              )}
            </Flex>
          </AccordionButton>
          <AccordionPanel>{children}</AccordionPanel>
        </>
      )}
    </AccordionItem>
  )
}

ExpandablePanel.defaultProps = {
  completedClosedContent: null,
}

ExpandablePanel.propTypes = {
  title: PropTypes.string.isRequired,
  completedClosedContent: PropTypes.node,
  isDisabled: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
}
